<template>
  <el-container class="tui-content" style="display: block;">
    <div>
      <el-select v-model="value"  filterable placeholder="请选择" @change="onChangeStripe">
          <el-option
            v-for="item in options"
            :key="item.label"
            :label="item.label"

            :value="item.value">
          </el-option>
        </el-select>
        <input type="text" v-model="search" @change="onChangeStripe()" style="height: 32px;"/>
        <input type="button" style="height: 36px;" @click="addNew()"  value="添加"/>
        <input type="text" v-model="rnum"  style="height: 32px;"/>
        <!-- <input type="button" @click="tuinum()" value="确定推荐数量" style="height: 32px;"/> -->
        <input type="button" @click="Refresh()" value="刷新数据" style="height: 32px;"/>
    </div>
    <div v-for="(items,indexs) in list" :key="indexs" style="margin-top: 20px;border: 1px solid #000;width: 900px;">
      <div v-for="(item,index) in items" :key="index" style="height: 100px;line-height: 100px;margin-top: 20px;">
        <p style="display: inline;padding-bottom: 30px;" @click="change(item['id'],item['name'])">{{item['name']}}</p>
        <div v-for="(img,ind) in item['img']" :key="ind" style="display: inline;margin-left: 20px;height: 100px;">

          <el-upload
            class="avatar-uploader"

            :action="UploadUrl(img.id)"
            :show-file-list="false"
            @click.native="ceshi(indexs,index,ind,img.id)"
            :on-success="handleAvatarSuccess"
            style="display: inline;vertical-align:middle;">

            <img v-if="img['img']" :src="img['img']" class="avatar" width="100" height="100" style="vertical-align:middle;margin-bottom: 20px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div style="margin-right: 15px;margin-bottom: 10px;text-align: right;"@click="del(items[0]['id'])">删除</div>
    </div>
   <el-dialog
     title="提示"
     :visible.sync="dialogVisible"
     width="30%"
     >
     <span>确认删除？</span>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="dialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="doDell()">确 定</el-button>
     </span>
   </el-dialog>
   <el-dialog
     title="修改"
     :visible.sync="centerDialogVisible"
     width="30%"
     center>
     <input type="text" class="searchT" v-model="addT"/>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="centerDialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="doAdd()">确 定</el-button>
     </span>
   </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        options: [],
        search:'',
        value: '',
        img1:'',
        img2:'',
        img3:'',
        list: [],
        c_id:0,
        c_name:'',
        centerDialogVisible:false,
        dialogVisible:false,
        addT:'',
        delId:0,
        rnum:200,
        imgId:0,

      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{
    tuinum(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	params:{
      		num:this.rnum,
          l_id:this.value

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/tuinumc'
      })
      .then(res=>{
        if(res.data.code == 200){
           var that = this
           this.options.forEach(function(item,index){
             if(that.value == item['value']){
                item['tui'] = that.rnum
             }
           })
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

        }else{

        }

      })
      .catch(err=>{

      });
    },
    Refresh(){

      if (this.value == 11 || this.value == 1111){
        const axiosInstance = this.$axios.create({
        	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
        	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
        });

        axiosInstance({
        	method:'post',
        	params:{
        		num:this.rnum,
            l_id:this.value

        	},
        	url:'http://fencip.yoooooo.com/index.php/index/data/refreshre'
        })
        .then(res=>{
        	this.loadList();

        })
        .catch(err=>{

        });
      }

    },
    del(id){
      this.delId = id

      this.dialogVisible = true
    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.delId,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/tuiCDel'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.dialogVisible = false
           this.$message({
           	type: 'success',
           	message: '删除成功'
           });
            this.loadList()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    addNew(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.value,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/tuiCNew'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.centerDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            this.loadList()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    change(id,name){
      this.c_id = id
      this.c_name = name
      this.centerDialogVisible = true
    },
    doAdd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.c_id,
          oname:this.c_name,
          name:this.addT
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/tuiCChange'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.centerDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
            this.loadList()
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    UploadUrl(id){
      return "http://data3.yoooooo.com/index.php/index/data/pythonImgSaveCan"
      // return "http://fencip.yoooooo.com/index.php/index/data/pythonImgChangeCan?id="+id
    },
    handleAvatarSuccess(res, file) {

      this.imgChange(this.imgId,file.response.data)
      this.list[this.img1][this.img2]['img'][this.img3]['img'] = URL.createObjectURL(file.raw);
    },
    ceshi(indexs,index,ind,id){
      this.img1 = indexs
      this.img2 = index
      this.img3 = ind
      this.imgId = id
    },
    imgChange(id,img){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          img:img

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgChangeCanNew'
      })
      .then(res=>{


        this.list[this.imageId]['img'] = res.data.data




      })
      .catch(err=>{

      });
    },
    onChangeStripe(){
      var that = this
      this.options.forEach(function(item,index){
        if(that.value == item['value']){
          that.rnum = item['tui']
        }
      })
      this.loadList()
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/pythonCanLists'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']
        this.rnum = this.options[0]['tui']
        this.loadList()
    	})
    	.catch(err=>{

    	});
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          lid:this.value,
          name:this.search
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/pythonCanList'
      })
      .then(res=>{
      	this.list = res.data;

      })
      .catch(err=>{

      });
    },


    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/tuic.vue